import React from "react";

const AddressContext = React.createContext();
AddressContext.displayName = "AddressContext";

function AddressProvider(props) {
  const [clearStateFieldTrigger, setClearStateFieldTrigger] = React.useState(0);

  const clearStateField = () => {
    setClearStateFieldTrigger(clearStateFieldTrigger + 1);
  };

  const value = { clearStateFieldTrigger, clearStateField };
  return <AddressContext.Provider value={value} {...props} />;
}

const useAddress = () => {
  const context = React.useContext(AddressContext);

  if (!context) {
    throw new Error("useAddress must be used inside an <FnrAddress />");
  }

  return context;
};

export { AddressProvider, useAddress };
